import { createSelector } from 'reselect';
import { navItems } from '../data/data.menu';
import * as base from './selectors.base';
import * as gallery from './selectors.gallery';
import * as parameters from './selectors.parameters';
import { raw } from './selectors.raw';
import * as single from './selectors.single';

export const $topBar = createSelector(
  base.$user,
  raw.$rawAppState,
  base.$isLoading,
  base.$breadcrumbs,
  single.$currentGeneratorId,
  base.$nextPrevModels,
  base.$isPlayground,
  base.$currentBarsIndex,
  base.$goldens,
  (
    user,
    appState,
    isLoading,
    breadcrumbs,
    generatorId,
    nextPrevModels,
    isPlayground,
    currentBarsIndex,
    goldens,
    projectType
  ) => {
    return {
      user,
      isLoading,
      breadcrumbs,
      generatorId,
      nextPrevModels,
      isPlayground,
      topBarIndex: currentBarsIndex.topBarIndex,
      isSlimVersion: appState.isSlimVersion,
      isCharging: appState.isCharging,
      totalGoldens: goldens.length,
      projectType,
    };
  }
);

export const $navBar = createSelector(
  base.$user,
  raw.$rawAppState,
  base.$models,
  base.$currentBarsIndex,
  base.$isEmployee,
  single.$projectType,
  (user, appState, models, currentBarsIndex, isEmployee, projectType) => {
    const { site } = appState;

    return {
      user,
      models,
      navItems: navItems.filter((item) => item.site === site || !item.site),
      currentBarsIndex,
      isLoading: appState.isLoading,
      isSlimVersion: appState.isSlimVersion,
      navbarWidth: appState.navbarWidthLeft,
      isEmployee,
      projectType,
    };
  }
);

export const $objectBar = createSelector(
  base.$user,
  base.$focusMode,
  base.$editMode,
  base.$currentBarsIndex,
  raw.$rawAppState,
  raw.$rawCurrentIds,
  parameters.$parametersWithValues,
  parameters.$parametersScene,
  single.$currentPaletteId,
  single.$currentMaterialPack,
  gallery.$materials,
  single.$currentSlotConfig,
  single.$projectType,
  (
    user,
    focusMode,
    editMode,
    currentBarsIndex,
    appState,
    currentIds,
    parametersWithValues,
    parametersScene,
    paletteId,
    materialPack,
    materialsGallery,
    slotConfig,
    projectType
  ) => {
    return {
      user,
      focusMode,
      editMode,
      currentBarsIndex,
      appState,
      currentIds,
      parametersWithValues,
      parametersScene,
      paletteId,
      materialPack,
      materialsGallery,
      slotConfig,
      isLoading: appState.isLoading,
      navbarWidth: appState.navbarWidthRight,
      slotId: currentIds.slotId,
      projectType,
    };
  }
);
